<template>
  <section class="banner" :class="expand.active">
    <div class="bg">
      <i v-for="item in expand.index"
         :class="`b_${item}`" />
    </div>
    <Swiper effect="coverflow"
            :speed="600"
            :coverflowEffect="{stretch:-300,slideShadows:false}"
            :autoplay="{disableOnInteraction:false,delay:6000}"
            :pagination="{clickable:true}"
            @slideChange="switchSwiper">
      <SwiperSlide class="item i_store">
        <div class="container">
          <a-typography-title :level="1">
            星汉未来致力于打造基于下一代Serverless技术的AI应用平台
          </a-typography-title>
          <a-typography-title :level="2">
            旨在迅速让AI成为企业的新质生产力引擎
          </a-typography-title>
          <a-typography-paragraph>
            {{
              '星汉未来作为一家AI应用平台厂商，提供AI应用管理、AI算力管理等全方位AI平台服务，以及AI数字人、AI绘画等AI应用服务。' +
              '凭借丰富的专利技术和不懈的产品创新，星汉未来致力于推动AI应用的落地和普及，让AI技术成为企业的增长新动力。'
            }}
          </a-typography-paragraph>
          <a-space :size="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'">
            <a class="button_n_1"
               @click="clickToStore()">
              SaaS服务
            </a>
            <a class="button_n_1"
               @click="clickToWhiteBook()">
              免费部署
            </a>
            <!--<a class="button_n_3"-->
            <!--   @click="$Store.Page().openModal('modalDownloadIFP')">-->
            <!--  私有化部署-->
            <!--</a>-->
            <!--<a class="button_n_3"-->
            <!--  @click="$Store.Page().openModal('modalFormCollection', 'deployment')">-->
            <!--  预约私有化部署-->
            <!--</a>-->
            <a class="button_n_1"
               @click="$router.push($Enum.RouterEnum.License)">
              获取License
            </a>
          </a-space>
        </div>
      </SwiperSlide>
      <SwiperSlide class="item i_store">
        <ProductBanner :isHome="true" @click="()=>$router.push($Enum.RouterEnum.ProductAidigitalHuman)" />
      </SwiperSlide>
    </Swiper>
  </section>
</template>

<script lang="ts" type="text/tsx">
import {
  CheckSquareOutlined,
  ClockCircleOutlined,
  EnvironmentOutlined
} from '@ant-design/icons-vue';
import SwiperCore, { Autoplay, Pagination, EffectCoverflow } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';

import { DataInterface } from '@interface/public';
import ImageBannerNewPC from '@resource/image/page/home/banner_news_1_text_pc.png';
import ImageBannerNewMobile from '@resource/image/page/home/banner_news_1_text_mobile.png';
import ProductBanner from '@template/page/productAidigitalHuman/productBanner.vue';

export default {
  name: 'home_banner',
  components: {
    CheckSquareOutlined,
    ClockCircleOutlined,
    EnvironmentOutlined,
    Swiper,
    SwiperSlide,
    ProductBanner
  },
  data(): DataInterface {
    return {
      href: {
        productSchedulX: 'https://mp.weixin.qq.com/s/IHsQWsdQeK36T3OkntO5pw',
        news: 'https://www.galaxy-future.com/newsDetail?id=47570340863279106'
      },
      file: {
        ImageBannerNewPC,
        ImageBannerNewMobile
      },
      expand: {
        active: '',
        index: [
          'store',
          'productCostPilot'
        ]
      }
    };
  },
  beforeCreate(): void {
    SwiperCore.use([ Autoplay, Pagination, EffectCoverflow ]);
  },
  mounted(): void {
    this.expand.active = `b_${ this.expand.index[0] }`;
  },
  methods: {
    /**
     * 切换Swiper
     * @param {*} data 数据
     */
    switchSwiper(data: any): void {
      this.expand.active = `b_${ this.expand.index[data.activeIndex] }`
    },
        /**
     * 点击去AI数字人
     */
     clickToAidigitalHuman(): void {
      // location.href = 'https://galaxy-future.feishu.cn/docx/BpfYdxcOYoNbXYxEHk8ce0OHnLd';
      open("https://aiavatars-monn34rc.apps.galaxy-future.com/");
    },
    
    /**
     * 点击去商城
     */
    clickToStore(): void {
      // location.href = $Config.Href.store;
      open($Config.Href.store);
    },
    
    /**
     * 点击去云平台
     */
    clickToCloud(): void {
      // location.href = $Config.Href.cloudDemo;
      open($Config.Href.cloudDemo);
    },
    
    /**
     * 点击去白皮书
     */
    clickToWhiteBook(): void {
      // location.href = 'https://galaxy-future.feishu.cn/docx/BpfYdxcOYoNbXYxEHk8ce0OHnLd';
      open('https://galaxy-future.feishu.cn/docx/BpfYdxcOYoNbXYxEHk8ce0OHnLd');
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/home/';

.banner {
  overflow: hidden;
  position: relative;
  z-index: 0;
  width: 100%;
  
  &.b_store .b_store , &.b_productCostPilot .b_productCostPilot {
    opacity: 1;
  }
  
  .b_store {
    // .bg('@{image}banner_store.jpg');
    .bg('@{image}banner_company.jpg');
    // .bg('@{image}banner_productSchedulX.jpg');
    // .bg('@{image}banner_productCostPilot.jpg');
    // .bg('@{image}banner_news.jpg');
    // .bg('@{image}banner_news_1.jpg');
    // .bg('@{image}banner_bookIndustry.jpg');
    // .bg('@{image}banner_bookCostOptimization.jpg');
    // .bg('@{image}banner_bookDevOps.jpg');
    // .bg('@{image}banner_financing.jpg');
  }
  .b_productCostPilot {
    .bg('@{image}banner_productCostPilot.jpg');
  }
  
  .bg {
    .position();
    z-index: 0;
    pointer-events: none;
    
    i {
      display: block;
      .position();
      background-size: cover !important;
      opacity: 0;
      .transition(opacity @time);
    }
  }
}

.swiper {
  position: relative;
  z-index: 1;
  width: 100%;
  
  .swiper-slide {
    position: relative;
    width: 100%;
  }
  
  &:deep(.swiper-pagination) {
    .position(bottom, 30px);
    max-width: @grid_xl+40px;
    padding: 0 @padding;
    margin: 0 auto;
    // text-align: left;
    
    .swiper-pagination-bullet {
      @style: width @time, background @time;
      width: 30px;
      height: 10px;
      margin: 0 15px 0 0;
      border-radius: 5px;
      background-color: @color_white;
      opacity: 0.5;
      .transition();
      
      &:last-child {
        margin: 0;
      }
      
      &.swiper-pagination-bullet-active {
        width: 60px;
        opacity: 1;
      }
    }
  }
}

.item {
  position: relative;
  padding: 0 @padding;
  
  &.i_store{
    .container {
      h1.ant-typography {
        margin: 0;
        .font(justify, @banner_title+4px, @color_white, @banner_title, true);
      }
      
      h2.ant-typography {
        margin: 20px 0 0;
        .font(justify, @title_sub+4px, @color_white, @title_sub, true);
      }
      
      div.ant-typography {
        max-width: 620px;
        margin: 15px 0 0;
        .font(justify, @text+@line, @color_white, @text);
      }
    }
  }
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: 120px 0 50px;
    margin: 0 auto;
    .borderBox();
    
    h1.ant-typography,
    div.ant-typography {
      .fontSpacing(2px);
    }
    
    div.ant-typography {
      position: relative;
      padding: 10px 0;
      text-shadow: 0 2px 5px fade(#10388C, 100);
      
      &::before {
        content: '';
        display: block;
        .center();
        z-index: -1;
        .bg('@{image}banner_text.png', 110%, 100%, true);
      }
    }
    
    .ant-space {
      margin-top: 20px;
    }
  }
}

@media screen and (max-width: -1px+@grid_xl) {
  .item {
    &.i_financing {
      .container {
        @f: -10px;
        
        h1.ant-typography {
          margin: 0;
          .font(center, @banner_title_big+@f, @color_white, @banner_title_big+@f, true);
        }
        
        h2.ant-typography {
          margin: 20px 0 0;
          .font(center, @banner_title+@f, @color_white, @banner_title+@f, true);
        }
      }
    }
    
    .container {
      padding: 90px 0 80px;
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .swiper {
    &:deep(.swiper-pagination) {
      bottom: 15px;
      text-align: center;
      
      .swiper-pagination-bullet {
        width: 20px;
        margin: 0 10px 0 0;
        
        &.swiper-pagination-bullet-active {
          width: 40px;
        }
      }
    }
  }
  
  .item {
    &.i_store {
      .container {
        h1.ant-typography {
          .font(justify, @banner_title_mo+4px, @color_white, @banner_title_mo, true);
        }
        
        h2.ant-typography {
          margin: 5px 0 0;
          .font(justify, @title_sub_mo+4px, @color_white, @title_sub_mo, true);
        }
        
        div.ant-typography {
          margin: 5px 0 0;
          .font(justify, @text_mo+@line_mo, @color_white, @text_mo);
        }
      }
    }
    
    .container {
      padding: 90px 0 50px;
      
      h1.ant-typography,
      div.ant-typography {
        .fontSpacing(0);
      }
      
      .ant-space {
        margin-top: 10px;
      }
    }
  }
}

@media screen and (max-width: -1px+@grid_xs) {
  .banner {
    .bg {
      i {
        background-position: center left !important;
      }
    }
  }
}
</style>